export const LEG_FIRST = 1;
export const LEG_MIDDLE = 2;
export const LEG_LAST = 3;
